import { createContext } from 'react';
import { IUseModal } from '~sharedComponents/Modal/useModal';

export const ReplenishmentTooltipModalContext = createContext<IUseModal>({} as IUseModal);
